
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable, inject } from '@angular/core';
/**
 *  Enridades */
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {

  private _translate = inject(TranslocoService);

  constructor() {
    super();
    this.getAndInitTranslations();

  }

  getAndInitTranslations(): void {

    this.itemsPerPageLabel  = this._translate.translate('Paginator.ITEMS_PER_PAGE');
    this.nextPageLabel  = this._translate.translate('Paginator.NEXT_PAGE');
    this.previousPageLabel  = this._translate.translate('Paginator.PREVIOUS_PAGE');
    this.lastPageLabel  = this._translate.translate('Paginator.LAST_PAGE');
    this.firstPageLabel  = this._translate.translate('Paginator.FIRST_PAGE');
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    //#registros de #(totalRegistros/#páginas)

    const totalPage = Math.floor(length / pageSize) + 1;

    if (page + 1 === totalPage) {
      pageSize = length - (page * pageSize);
    }

    return `${startIndex + 1} a ${endIndex} de ${length} registros`;
    //return `${page + 1} - ${pageSize} de ${totalPage}`;
  };

}
